export default __webpack_public_path__ + "static/media/completed.4ac32d79.svg";